// ** React Imports

// ** Third Party Components
import * as yup from "yup"
import { useFormik } from "formik"

// ** Reactstrap Imports
import {
  //  Form,
  FormFeedback,
  Input,
  Label,
  Button,
  Modal,
  UncontrolledAccordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Table
} from "reactstrap"
import Select from "react-select"
import CustomSpinner from "../../../../components/spinners/CustomSpinner"
import { useEffect, useState } from "react"

// ** Styles

const HogarSeguroForm = (props) => {
  // ** State
  const moneyFormat = Intl.NumberFormat('es-MX')
  const catalogoContratante = [
    {
      label: 'Propietario',
      value: 'propietario'
    },
    {
      label: 'Arrendatario',
      value: 'arrendatario'
    }
  ]
  const catalogoPercibeRentas = [
    {
      label: 'Si',
      value: 'si'
    },
    {
      label: 'No',
      value: 'no'
    }
  ]
  const catalogoMuros = [
    { label: "Tabique", value: "tabique" },
    { label: "Adobe", value: "adove" },
    { label: "Block", value: "block" },
    { label: "Block, de concreto", value: "bc" },
    { label: "Concreto, Armado", value: "ca" },
    { label: "Cristal, con columnas de acero", value: "ca" },
    { label: "Cristal, con columnas de concreto", value: "cc" },
    { label: "Ladrillo", value: "ladrillo" },
    { label: "Lamina, de asbesto o cemento", value: "lac" },
    { label: "Lamina, metalica", value: "lm" },
    { label: "Mamposteria", value: "mamposteria" },
    { label: "Multipanel", value: "multipanel" },
    { label: "Piedra", value: "piedra" },
    { label: "Siporex", value: "siporex" },
    { label: "Tablaroca", value: "tablaroca" },
    { label: "Tejamanil", value: "tejamanil" },
    { label: "Tepetate", value: "tepetate" },
    { label: "Vidrio, block no mayor a 12 m2", value: "vb" }
  ]
  const catalogoTipoVivienda = [
    { label: "Lujo", value: "lujo" },
    { label: "Alto", value: "alto" },
    { label: "Medio", value: "medio" },
    { label: "Económico", value: "economico" }
  ]
  const catalogoRegimenFiscal = [
    {
      label: 'Persona Fisica',
      value: 'persona fisica'
    },
    {
      label: 'Persona Moral',
      value: 'persona moral'
    }
  ]
  const catalogoCiudad = [
    {
      label: 'CDMX',
      value: 'CDMX'
    },
    {
      label: 'Tijuana',
      value: 'Tijuana'
    },
    {
      label: 'Mexicali',
      value: 'Mexicali'
    },
    {
      label: 'Rosarito',
      value: 'Rosarito'
    }
  ]
  const catalogoRegimen = [
    { label: "Vivienda Sola", value: "Vivienda Sola" },
    { label: "Vivienda en Condomio Horizontal", value: "Vivienda en Condomio Horizontal" },
    { label: "Vivienda en Condomio Vertical", value: "Vivienda en Condomio Vertical" }
  ]

  const validationSchema = () => {
    return yup.object({
    })
  }

  function initialValues() {
    if (props.accion === 1) {
      return {
        estado: "",
        poblacion: "",
        cp: "",
        colonia: "",
        contratante: "",
        percibeRentas: "",
        tipoAlarma: "",
        muros: "",
        tipoVivienda: "",
        valorMetro: "",

        dmEdificio: "",
        saContenidos: "",
        saEscombros: "",
        saGastosE: "",
        saCristales: "",
        saRCivil: "",
        saPerdidaIngresos: "",
        saRcontenidos: "",
        saRoboFuera: "",
        saDinero: "",

        regimenFiscal: "",
        nombre: "",
        apellidoPaterno: "",
        curp: "",
        telefono: "",
        sexo: "",
        calle: "",
        ciudad: "",
        regimen: "",

        regimenFiscalBeneficiario: "",
        nombreBeneficiario: ""
      }
    } else {
      return props.data
    }
  }

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    onSubmit: (data, { resetForm }) => {      
      data = {
        ...data,
        accion: props.accion,
        slug: "hogar-seguro",
        tipo: "Personal",
        nombre: "Hogar seguro"
      }
      props.administrar(data, props.handleSuccess)
      resetForm()
    }
  })
  // Operaciones Suma Asegurada
  const [dmContenidos, setDmContenidos] = useState(0)
  const [escombros, setEscombros] = useState(0)
  const [gastosEx, setGastosEx] = useState(0)
  const [cristales, setCristales] = useState(0)
  const [responsabilidadCivil, setResponsabilidadCivil] = useState(0)
  const [perdidaIngresos, setPerdidaIngresos] = useState(0)
  const [roboContenidos, setRoboContenidos] = useState(0)
  const [roboFuera, setRoboFuera] = useState(0)
  const [dinero, setDinero] = useState(0)

  useEffect(() => {

    // Operaciones Suma Asegurada
    if (formik.values.saContenidos != 0 && formik.values.dmEdificio) {
      setDmContenidos((parseFloat(formik.values.saContenidos) / 100) * parseFloat(formik.values.dmEdificio))
    }
    if (formik.values.saEscombros != 0 && formik.values.dmEdificio) {
      setEscombros((parseFloat(formik.values.saEscombros) / 100) * parseFloat(formik.values.dmEdificio))
    }
    if (formik.values.saGastosE != 0 && formik.values.dmEdificio) {
      setGastosEx((parseFloat(formik.values.saGastosE) / 100) * parseFloat(formik.values.dmEdificio))
    }
    if (formik.values.saCristales != 0 && formik.values.dmEdificio) {
      setCristales((parseFloat(formik.values.saCristales) / 100) * parseFloat(formik.values.dmEdificio))
    }
    if (formik.values.saRCivil != 0 && formik.values.dmEdificio) {
      setResponsabilidadCivil((parseFloat(formik.values.saRCivil) / 100) * parseFloat(formik.values.dmEdificio))
    }
    if (formik.values.saPerdidaIngresos != 0 && formik.values.dmEdificio) {
      setPerdidaIngresos((parseFloat(formik.values.saPerdidaIngresos) / 100) * parseFloat(formik.values.dmEdificio))
    }
    if (formik.values.saRcontenidos != 0 && formik.values.dmEdificio) {
      setRoboContenidos((parseFloat(formik.values.saRcontenidos) / 100) * parseFloat(formik.values.dmEdificio))
    }
    if (formik.values.saRoboFuera != 0 && formik.values.dmEdificio) {
      setRoboFuera((parseFloat(formik.values.saRoboFuera) / 100) * parseFloat(formik.values.dmEdificio))
    }
    if (formik.values.saDinero != 0 && formik.values.dmEdificio) {
      setDinero((parseFloat(formik.values.saDinero) / 100) * parseFloat(formik.values.dmEdificio))
    }

  }, [formik.values.dmEdificio, formik.values.saContenidos, formik.values.saEscombros, formik.values.saGastosE, formik.values.saCristales, formik.values.saRCivil, formik.values.saPerdidaIngresos, formik.values.saRcontenidos, formik.values.saRoboFuera, formik.values.saDinero])

  return (
    <div>

      <Modal isOpen={props.loading}>
        <CustomSpinner />
      </Modal>
      <h1 className="mb-2 col-12 text-center">Hogar seguro</h1>
      <UncontrolledAccordion defaultOpen="1">
        <AccordionItem>
          <AccordionHeader targetId='1'>
            Datos de la ubicacion
          </AccordionHeader>
          <AccordionBody accordionId='1'>

            <div>
              <div className="mb-1">
                <Label className="form-label" for="tipo">
                  Estado:
                </Label>
                <Input
                  invalid={formik.errors.estado && true}
                  value={formik.values.estado}
                  onChange={(e) => {
                    formik.setFieldValue("estado", e.target.value)
                  }}
                />
                {formik.errors.estado && (
                  <FormFeedback>{formik.errors.estado}</FormFeedback>
                )}
              </div>
              <div className="mb-1">
                <Label className="form-label" for="tipo">
                  Poblacion:
                </Label>
                <Input
                  invalid={formik.errors.poblacion && true}
                  value={formik.values.poblacion}
                  onChange={(e) => {
                    formik.setFieldValue("poblacion", e.target.value)
                  }}
                />
                {formik.errors.poblacion && (
                  <FormFeedback>{formik.errors.poblacion}</FormFeedback>
                )}
              </div>
              <div className="mb-1">
                <Label className="form-label" for="tipo">
                  Codigo postal:
                </Label>
                <Input
                  invalid={formik.errors.cp && true}
                  value={formik.values.cp}
                  onChange={(e) => {
                    formik.setFieldValue("cp", e.target.value)
                  }}
                />
                {formik.errors.cp && (
                  <FormFeedback>{formik.errors.cp}</FormFeedback>
                )}
              </div>
            </div>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Colonia:
              </Label>
              <Input
                invalid={formik.errors.colonia && true}
                value={formik.values.colonia}
                onChange={(e) => {
                  formik.setFieldValue("colonia", e.target.value)
                }}
              />
              {formik.errors.colonia && (
                <FormFeedback>{formik.errors.colonia}</FormFeedback>
              )}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Contratante:
              </Label>
              <Select
                className='react-select'
                classNamePrefix='select'
                defaultValue={catalogoContratante[0]}
                options={catalogoContratante}
                isClearable={false}
                onChange={(e) => {
                  formik.setFieldValue("contratante", e.value)
                }}
              />
              {formik.errors.contratante && (
                <FormFeedback>{formik.errors.contratante}</FormFeedback>
              )}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Percibe rentas:
              </Label>
              <Select
                className='react-select'
                classNamePrefix='select'
                defaultValue={catalogoPercibeRentas[0]}
                options={catalogoPercibeRentas}
                isClearable={false}
                onChange={(e) => {
                  formik.setFieldValue("percibeRentas", e.value)
                }}
              />
              {formik.errors.percibeRentas && (
                <FormFeedback>{formik.errors.percibeRentas}</FormFeedback>
              )}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Tipo de alarma:
              </Label>
              <Input
                invalid={formik.errors.tipoAlarma && true}
                value={formik.values.tipoAlarma}
                onChange={(e) => {
                  formik.setFieldValue("tipoAlarma", e.target.value)
                }}
              />
              {formik.errors.tipoAlarma && (
                <FormFeedback>{formik.errors.tipoAlarma}</FormFeedback>
              )}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Muros:
              </Label>
              <Select
                className='react-select'
                classNamePrefix='select'
                defaultValue={catalogoMuros[0]}
                options={catalogoMuros}
                isClearable={false}
                onChange={(e) => {
                  formik.setFieldValue("muros", e.value)
                }}
              />

              {formik.errors.muros && (
                <FormFeedback>{formik.errors.muros}</FormFeedback>
              )}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Tipo de vivienda:
              </Label>
              <Select
                className='react-select'
                classNamePrefix='select'
                defaultValue={catalogoTipoVivienda[0]}
                options={catalogoTipoVivienda}
                isClearable={false}
                onChange={(e) => {
                  formik.setFieldValue("tipoVivienda", e.value)
                }}
              />

              {formik.errors.tipoVivienda && (
                <FormFeedback>{formik.errors.tipoVivienda}</FormFeedback>
              )}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Valor del M2:
              </Label>
              <Input
                type='number'
                invalid={formik.errors.valorMetro && true}
                value={formik.values.valorMetro}
                onChange={(e) => {
                  formik.setFieldValue("valorMetro", e.target.value)
                }}
              />

              {formik.errors.valorMetro && (
                <FormFeedback>{formik.errors.valorMetro}</FormFeedback>
              )}
            </div>

          </AccordionBody>
        </AccordionItem>
        <AccordionItem>
          <AccordionHeader targetId='2'>
            Coberturas
          </AccordionHeader>
          <AccordionBody accordionId='2'>
            <Table responsive>
              <thead>
                <tr>
                  <th>Seccion</th>
                  <th>% S.A.</th>
                  <th>Suma Asegurada</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>DM Edificio</td>
                  <td></td>
                  <td>
                    <Input
                      type='number'
                      value={formik.values.dmEdificio}
                      onChange={(e) => {
                        formik.setFieldValue("dmEdificio", e.target.value)
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>DM Contenidos</td>
                  <td>
                    <Input
                      type='number'
                      value={formik.values.saContenidos}
                      onChange={(e) => {
                        formik.setFieldValue("saContenidos", e.target.value)
                      }}
                    />
                  </td>
                  <td>{moneyFormat.format(dmContenidos)}</td>
                </tr>
                <tr>
                  <td>Remocion Escombros</td>
                  <td>
                    <Input
                      type='number'
                      value={formik.values.saEscombros}
                      onChange={(e) => {
                        formik.setFieldValue("saEscombros", e.target.value)
                      }}
                    />
                  </td>
                  <td>{moneyFormat.format(escombros)}</td>
                </tr><tr>
                  <td>Gastos Extraordinarios</td>
                  <td>
                    <Input
                      type='number'
                      value={formik.values.saGastosE}
                      onChange={(e) => {
                        formik.setFieldValue("saGastosE", e.target.value)
                      }}
                    />
                  </td>
                  <td>{moneyFormat.format(gastosEx)}</td>
                </tr><tr>
                  <td>Cristales</td>
                  <td>
                    <Input
                      type='number'
                      value={formik.values.saCristales}
                      onChange={(e) => {
                        formik.setFieldValue("saCristales", e.target.value)
                      }}
                    />
                  </td>
                  <td>{moneyFormat.format(cristales)}</td>
                </tr><tr>
                  <td>Responsabilidad Civil</td>
                  <td>
                    <Input
                      type='number'
                      value={formik.values.saRCivil}
                      onChange={(e) => {
                        formik.setFieldValue("saRCivil", e.target.value)
                      }}
                    />
                  </td>
                  <td>{moneyFormat.format(responsabilidadCivil)}</td>
                </tr><tr>
                  <td>Perdida Ingresos</td>
                  <td>
                    <Input
                      type='number'
                      value={formik.values.saPerdidaIngresos}
                      onChange={(e) => {
                        formik.setFieldValue("saPerdidaIngresos", e.target.value)
                      }}
                    />
                  </td>
                  <td>{moneyFormat.format(perdidaIngresos)}</td>
                </tr><tr>
                  <td>Robo Contenidos</td>
                  <td>
                    <Input
                      type='number'
                      value={formik.values.saRcontenidos}
                      onChange={(e) => {
                        formik.setFieldValue("saRcontenidos", e.target.value)
                      }}
                    />
                  </td>
                  <td>{moneyFormat.format(roboContenidos)}</td>
                </tr><tr>
                  <td>Robo Fuera</td>
                  <td>
                    <Input
                      type='number'
                      value={formik.values.saRoboFuera}
                      onChange={(e) => {
                        formik.setFieldValue("saRoboFuera", e.target.value)
                      }}
                    />
                  </td>
                  <td>{moneyFormat.format(roboFuera)}</td>
                </tr><tr>
                  <td>Dinero y Valores</td>
                  <td>
                    <Input
                      type='number'
                      value={formik.values.saDinero}
                      onChange={(e) => {
                        formik.setFieldValue("saDinero", e.target.value)
                      }}
                    />
                  </td>
                  <td>{moneyFormat.format(dinero)}</td>
                </tr>
              </tbody>
            </Table>
          </AccordionBody>
        </AccordionItem>
        <AccordionItem>
          <AccordionHeader targetId='3'>
            Titular de la ubicación
          </AccordionHeader>
          <AccordionBody accordionId='3'>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Régimen Fiscal:
              </Label>
              <Select
                className='react-select'
                classNamePrefix='select'
                defaultValue={catalogoRegimenFiscal[0]}
                options={catalogoRegimenFiscal}
                isClearable={false}
                onChange={(e) => {
                  formik.setFieldValue("regimenFiscal", e.value)
                }}
              />

              {formik.errors.regimenFiscal && (
                <FormFeedback>{formik.errors.regimenFiscal}</FormFeedback>
              )}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                CURP:
              </Label>
              <Input
                invalid={formik.errors.curp && true}
                value={formik.values.curp}
                onChange={(e) => {
                  formik.setFieldValue("curp", e.target.value)
                }}
              />
              {formik.errors.curp && (
                <FormFeedback>{formik.errors.curp}</FormFeedback>
              )}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Calle:
              </Label>
              <Input
                invalid={formik.errors.calle && true}
                value={formik.values.calle}
                onChange={(e) => {
                  formik.setFieldValue("calle", e.target.value)
                }}
              />
              {formik.errors.calle && (
                <FormFeedback>{formik.errors.calle}</FormFeedback>
              )}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Ciudad:
              </Label>
              <Select
                className='react-select'
                classNamePrefix='select'
                defaultValue={catalogoCiudad[0]}
                options={catalogoCiudad}
                isClearable={false}
                onChange={(e) => {
                  formik.setFieldValue("ciudad", e.value)
                }}
              />

              {formik.errors.ciudad && (
                <FormFeedback>{formik.errors.ciudad}</FormFeedback>
              )}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Régimen:
              </Label>
              <Select
                className='react-select'
                classNamePrefix='select'
                defaultValue={catalogoRegimen[0]}
                options={catalogoRegimen}
                isClearable={false}
                onChange={(e) => {
                  formik.setFieldValue("regimen", e.value)
                }}
              />

              {formik.errors.regimen && (
                <FormFeedback>{formik.errors.regimen}</FormFeedback>
              )}
            </div>
          </AccordionBody>
        </AccordionItem>
        <AccordionItem>
          <AccordionHeader targetId='4'>
            Beneficiario Preferente
          </AccordionHeader>
          <AccordionBody accordionId='4'>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Régimen Fiscal del beneficiario:
              </Label>
              <Select
                className='react-select'
                classNamePrefix='select'
                defaultValue={catalogoRegimen[0]}
                options={catalogoRegimen}
                isClearable={false}
                onChange={(e) => {
                  formik.setFieldValue("regimenFiscalBeneficiario", e.value)
                }}
              />

              {formik.errors.regimenFiscalBeneficiario && (
                <FormFeedback>{formik.errors.regimenFiscalBeneficiario}</FormFeedback>
              )}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="tipo">
                Nombre completo del beneficiario:
              </Label>
              <Input
                invalid={formik.errors.nombreBeneficiario && true}
                value={formik.values.nombreBeneficiario}
                onChange={(e) => {
                  formik.setFieldValue("nombreBeneficiario", e.target.value)
                }}
              />
              {formik.errors.nombreBeneficiario && (
                <FormFeedback>{formik.errors.nombreBeneficiario}</FormFeedback>
              )}
            </div>
          </AccordionBody>
        </AccordionItem>
      </UncontrolledAccordion>
      <div className="d-flex justify-content-end">
        <Button className="me-1" color="primary" onClick={formik.handleSubmit}>
          {props.accion === 1 ? "Guardar" : "Guardar cambios"}
        </Button>
      </div>
    </div >
  )
}

export default HogarSeguroForm
